import { useContext } from "react";
import { FormContextMA } from "../form-context";
import { Section, H2, H3, Divider } from "./common-components";

export const PharmacistMonitoringPlans = ({formType}) => {
  const {} = useContext(FormContextMA);
  // TODO: text for this section?
  return (
    <Section formType={formType}>
      <H2>Pharmacist Monitoring Follow Up Plan(s)</H2>
      <ul className="list-disc space-y-[0.0416667in] text-[0.125in] ml-[0.25in]">
        <li>
          If symptoms improving → refills will be provided for allergy season;
        </li>
        <li>
          Once symptoms are well controlled, maintenance dose of INCS will be
          recommended = If symptoms improving, but require chronic, year-round
          therapy, as patient’s seasons overlap → refills will be provided for
          up to 1 year;
        </li>
        <li>
          If symptoms only partially improved on oral antihistamine→ will
          consider switching to INCS
        </li>
        <li>
          If symptoms only partially improved on INCS→ May consider adding a
          nasal antihistamine;
        </li>
      </ul>
      <Divider />
      <H3>Further follow up with Primary Care Provider will be recommended:</H3>
      <ul className="list-disc space-y-[0.0416667in] text-[0.125in] ml-[0.25in]">
        <li>If no further improvements with current treatment </li>
        <li>If symptoms not improved at all </li>
      </ul>
    </Section>
  );
};
